import React from "react";
import { MarkerType } from "react-flow-renderer";
import { Link } from "react-router-dom";
// const level1 = "#8dccad";
// const level2 = "#f5cc7f";
// const level3 = "#7b9fe0";
// const level4 = "#f27c8d";
// const level5 = "#fdb367";
// const level6 = "#de723a";
// const black = "black";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "rgb(0, 25, 59, 0.9)";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Flexbox!</strong>
          <p>
            Using display: flex; allows you to start your flexbox journey!
            <br />
            <br />
            Utilize the minimap in the bottom right as a guide. I recommend
            going from left to right
          </p>
        </>
      ),
    },
    position: { x: -300, y: -378 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  // {
  //   id: "2",
  //   data: {
  //     label: (
  //       <>
  //         <strong>Display, Direction, & Wrap</strong>
  //       </>
  //     ),
  //   },
  //   position: { x: -500, y: 300 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 600,
  //   },
  // },

  {
    id: "2",
    data: {
      label: (
        <>
          <strong>Flex Direction</strong>
          <p>
            flex-direction sets how flex items are placed in the flex container
            defining the main axis and the direction (normal or reversed)
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="flexbox align vs justify"
            src="https://codepen.io/jonathanelias1/embed/preview/XWqBypB?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/XWqBypB">
              flexbox align vs justify
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -2418, y: 450 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  {
    id: "4",

    data: {
      label: (
        <>
          <strong>Align vs Justify</strong>
        </>
      ),
    },
    position: { x: -110, y: 140 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "5",

    data: {
      label: (
        <>
          <strong>Basics</strong>
        </>
      ),
    },
    position: { x: -1670, y: 140 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 300,
    },
  },
  // {
  //   id: "4",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Align Items</strong>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 300 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 400,
  //   },
  // },
  // {
  //   id: "5",
  //   data: {
  //     label: (
  //       <>
  //         <strong>Before display: flex;</strong>
  //         <p>
  //           background: #8bee86; <br />
  //           margin: 0.5em; <br />
  //           padding: 0.5em; <br />
  //           color: #424656;
  //         </p>
  //         <div className="flex-item">flex item 1</div>
  //         <div className="flex-item">flex item 2</div>
  //         <div className="flex-item">flex item 3</div>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 50 },
  //   style: {
  //     background: level3,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 600,
  //   },
  // },
  // {
  //   id: "6",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Sort the items in a row</strong>
  //         <p className="css-code">
  //           {" "}
  //           display: flex; <br /> flex-direction: row;
  //         </p>
  //         <div className="display-flex-row">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -600, y: 400 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },
  // {
  //   id: "7",
  //   data: {
  //     label: (
  //       <>
  //         <strong>Sort the items in a column</strong>
  //         <p className="css-code">
  //           {" "}
  //           display: flex; <br /> flex-direction: column;
  //         </p>
  //         <div className="display-flex-column">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -300, y: 400 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },
  // {
  //   id: "8",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Reverse the items in a row</strong>
  //         <p className="css-code">
  //           {" "}
  //           display: flex; <br /> flex-direction: row-reverse;
  //         </p>
  //         <div className="display-flex-row-reverse">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -600, y: 700 },
  //   style: {
  //     background: level5,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "9",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Reverse the items in a column</strong>
  //         <p className="css-code">
  //           {" "}
  //           display: flex; <br />
  //           flex-direction: column-reverse;
  //         </p>
  //         <div className="display-flex-column-reverse">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -300, y: 700 },
  //   style: {
  //     background: level5,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  {
    id: "10",

    data: {
      label: (
        <>
          <strong>Flex Wrap</strong>
          <p>
            flex-wrap sets whether flex items are forced onto one line or can
            wrap onto multiple lines. If wrapping is allowed, it sets the
            direction that lines are stacked.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="flex direction"
            src="https://codepen.io/jonathanelias1/embed/preview/rNvrQrQ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/rNvrQrQ">
              flex direction
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1450, y: 450 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  {
    id: "11",
    data: {
      label: (
        <>
          <strong>Align items</strong>
          <p>
            align-items = sets the align-self value on all direct children as a
            group. In Flexbox, it controls the alignment of items on the Cross
            Axis.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="flex align items"
            src="https://codepen.io/jonathanelias1/embed/preview/eYrjQqx?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/eYrjQqx">
              flex align items
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -414, y: 450 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  {
    id: "12",
    data: {
      label: (
        <>
          <strong>Justify items</strong>
          <p>
            There is no justify-items property for flexbox, instead use justify
            content.
          </p>
        </>
      ),
    },
    position: { x: 519, y: 450 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "14",

    data: {
      label: (
        <>
          <strong>Justify Self</strong>
          <p>
            There is no justify-self property for flexbox, instead use justify
            content.
          </p>
        </>
      ),
    },
    position: { x: 519, y: 1640 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  // {
  //   id: "10",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Items wrapping outside the boxes?</strong>
  //         <p>
  //           The default of flex is nowrap so changing it to wrap will fix it.
  //           flex-wrap sets whether flex items are forced onto one line or can wrap onto multiple lines. If wrapping is allowed, it sets the direction that lines are stacked.
  //         </p>
  //         <p className="css-code">
  //           display: flex; <br></br> flex-direction: row;
  //           <br></br>
  //           flex-wrap: wrap;
  //         </p>
  //         <div className="display-flex-row-wrap">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //           <div className="flex-item">flex item 4</div>
  //           <div className="flex-item">flex item 5</div>
  //           <div className="flex-item">flex item 6</div>
  //           <div className="flex-item">flex item 7</div>
  //           <div className="flex-item">flex item 8</div>
  //           <div className="flex-item">flex item 9</div>
  //           <div className="flex-item">
  //             flex item 10 is longer but still wraps
  //           </div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -450, y: 1000 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "12",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Align items left</strong>
  //         <p className="css-code">
  //           {" "}
  //           display: flex; <br /> flex-direction: row;
  //           <br />
  //           justify-content: flex-start;
  //         </p>

  //         <div className="display-flex-row-start">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 640, y: 560 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  // {
  //   id: "13",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Center items</strong>
  //         <p className="css-code">
  //           display: flex; <br /> flex-direction: row;
  //           <br />
  //           justify-content: center;
  //         </p>

  //         <div className="display-flex-row-center">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1017, y: 560 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  // {
  //   id: "14",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Align items right</strong>
  //         <p className="css-code">
  //           display: flex; <br /> flex-direction: row;
  //           <br />
  //           justify-content: flex-end;
  //         </p>

  //         <div className="display-flex-row-start">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1403, y: 560 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  {
    id: "15",

    data: {
      label: (
        <>
          <strong>Align Self</strong>
          <p>
            align-self = overrides a grid or flex item's align-items value. In
            Flexbox, it aligns the item on the cross axis.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="flex align items"
            src="https://codepen.io/jonathanelias1/embed/preview/poVOWvM?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/poVOWvM">
              flex align items
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -414, y: 1640 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  {
    id: "16",

    data: {
      label: (
        <>
          <strong>Align Content</strong>
          <p>
            align-content = sets the distribution of space between and around
            content items along a flexbox's cross-axis. <br />
            <br />
            align-content requires flex wrap to work because the align-content
            property just aligns the flex lines of the flex-wrap property.
            <br />
            <br />
            Note: There must be multiple lines of items for this property to
            have any effect!
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="flex align content"
            src="https://codepen.io/jonathanelias1/embed/preview/qBYMPPV?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/qBYMPPV">
              flex align content
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -414, y: 2834 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  {
    id: "17",

    data: {
      label: (
        <>
          <strong>Justify Content</strong>
          <p>
            justify-content = defines how the browser distributes space between
            and around content items along the main-axis of a flex container.{" "}
            <br />
            <br />
            Use the justify-content property to align the items on the main-axis
            (horizontally).
          </p>

          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="flex align content"
            src="https://codepen.io/jonathanelias1/embed/preview/BaxOwGX?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/BaxOwGX">
              flex align content
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 461, y: 2834 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1100,
    },
  },

  // {
  //   id: "15",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Space around items</strong>
  //         <p className="css-code">
  //           display: flex; <br /> flex-direction: row;
  //           <br />
  //           justify-content: space-around;
  //         </p>

  //         <div className="display-flex-row-around">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 640, y: 840 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  // {
  //   id: "16",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Space items evenly</strong>
  //         <p className="css-code">
  //           display: flex; <br /> flex-direction: row;
  //           <br />
  //           justify-content: space-evenly;
  //         </p>

  //         <div className="display-flex-row-evenly">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1017, y: 840 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  // {
  //   id: "17",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Space between items</strong>
  //         <p className="css-code">
  //           display: flex; <br /> flex-direction: row;
  //           <br />
  //           justify-content: space-between;
  //         </p>

  //         <div className="display-flex-row-between">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1403, y: 840 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  // {
  //   id: "19",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Start items on top</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row;
  //           <br />
  //           justify-content: center; <br />
  //           height: 200px; <br />
  //           align-items: flex-start;
  //         </p>

  //         <div className="display-flex-row-align-top">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 3, y: 982 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "20",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Start items on bottom</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row;
  //           <br />
  //           justify-content: center; <br />
  //           height: 200px; <br />
  //           align-items: flex-end;
  //         </p>

  //         <div className="display-flex-row-align-end">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -158, y: 982 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "21",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Center Items</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row;
  //           <br />
  //           justify-content: center; <br />
  //           height: 200px; <br />
  //           align-items: center;
  //         </p>

  //         <div className="display-flex-row-align-center">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 315, y: 982 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "22",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Align items based on 1st thing in them (Baseline)</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row;
  //           <br />
  //           justify-content: center; <br />
  //           height: 200px; <br />
  //           align-items: baseline;
  //         </p>

  //         <div className="display-flex-align-baseline">
  //           <div className="flex-item">
  //             <h1 className="flex-item-big">flex item 1</h1>
  //           </div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">a bunch of extra text</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 161, y: 982 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  {
    id: "23",
    data: {
      label: (
        <>
          <strong>Resize based on window/device size</strong>
        </>
      ),
    },
    position: { x: 1364, y: 140 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "24",

    data: {
      label: (
        <>
          <strong>
            Start Items as columns or rows then change them to their opposites
            when screen size is small.
          </strong>
          <p>
            Note: If you click into this codepen and resize the browser when
            there, you can watch this effect take place.
          </p>
          <p>
            Using @media allows us to change our flex layout options depending
            on the width of the device users visit our site on. Learn more about
            the @media property
            <Link className="link-to-mobile" to="/mobile">
              here.
            </Link>
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="Untitled"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjyGVE?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjyGVE">Untitled</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1265, y: 450 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  // {
  //   id: "24",

  //   data: {
  //     label: (
  //       <>
  //         <strong>
  //           Start Items as columns or rows then change them to their opposites when screen size is
  //           small.
  //         </strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: column; <br />
  //           For smaller screens: <br />
  //           @media (min-width:1000px) <br />
  //           {`{.ContainerName{
  //             flex-direction:row;
  //           }}`}
  //         </p>

  //         <div className="display-flex-row-mobile">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1815, y: 550 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "25",
  //   data: {
  //     label: (
  //       <>
  //         <strong className="test">Align individual items (Align self)</strong>
  //       </>
  //     ),
  //   },
  //   position: { x: 100, y: 1500 },
  //   style: {
  //     background: level5,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "26",

  //   data: {
  //     label: (
  //       <>
  //         <strong>
  //           Align individual item on top or left depending on flex-direction
  //         </strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row; <br />
  //           Flex item 1: <br />
  //           align-self: flex-start;
  //         </p>

  //         <div className="flex-item-align-self-container">
  //           <div className="flex-item-start">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 400, y: 1800 },
  //   style: {
  //     background: level6,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "27",

  //   data: {
  //     label: (
  //       <>
  //         <strong>
  //           Align individual item on bottom or right depending on flex-direction
  //         </strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row; <br />
  //           Flex item 1: <br />
  //           align-self: flex-end;
  //         </p>

  //         <div className="flex-item-align-self-container">
  //           <div className="flex-item-end">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 200, y: 1800 },
  //   style: {
  //     background: level6,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "28",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Align individual item in center</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row; <br />
  //           Flex item 1: <br />
  //           align-self: center;
  //         </p>

  //         <div className="flex-item-align-self-container">
  //           <div className="flex-item-center">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 1800 },
  //   style: {
  //     background: level6,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "29",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Stretch individual item</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row; <br />
  //           Flex item 1: <br />
  //           align-self: Stretch;
  //         </p>

  //         <div className="flex-item-align-self-container">
  //           <div className="flex-item-stretch">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -250, y: 1800 },
  //   style: {
  //     background: level6,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // {
  //   id: "30",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Stretch items</strong>
  //         <p className="css-code">
  //           display: flex; <br />
  //           flex-direction: row;
  //           <br />
  //           justify-content: center; <br />
  //           height: 200px; <br />
  //           align-items: stretch;
  //         </p>

  //         <div className="display-flex-row-align-stretch">
  //           <div className="flex-item">flex item 1</div>
  //           <div className="flex-item">flex item 2</div>
  //           <div className="flex-item">flex item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 470, y: 982 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //   },
  // },

  // End of items
];

export const edges = [
  {
    id: "e1-5",
    source: "1",
    target: "5",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-4",
    source: "1",
    target: "4",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-23",
    source: "1",
    target: "23",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Basics
  {
    id: "e5-2",
    source: "5",
    target: "2",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e5-10",
    source: "5",
    target: "10",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Align vs Justify

  {
    id: "e4-11",
    source: "4",
    target: "11",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e4-12",
    source: "4",
    target: "12",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e4-14",
    source: "4",
    target: "14",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e4-15",
    source: "4",
    target: "15",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e4-16",
    source: "4",
    target: "16",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e4-17",
    source: "4",
    target: "17",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Resize
  {
    id: "e23-24",
    source: "23",
    target: "24",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  // {
  //   id: "e5-2",
  //   source: "5",
  //   target: "2",
  //   label: "this is an edge label",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e5-3",
  //   source: "5",
  //   target: "3",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e5-4",
  //   source: "5",
  //   target: "4",
  //   // animated: true,
  //   // label: "animated edge",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e1-5",
  //   source: "1",
  //   target: "5",
  //   // label: "edge with arrow head",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e2-6",
  //   source: "2",
  //   target: "6",
  //   // type: "smoothstep",
  //   // label: "smooth step edge",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e2-7",
  //   source: "2",
  //   target: "7",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  //   // type: "step",
  //   // style: { stroke: "#f6ab6c" },
  //   // label: "a step edge",
  //   // animated: true,
  //   // labelStyle: { fill: "#f6ab6c", fontWeight: 700 },
  // },

  // {
  //   id: "e6-8",
  //   source: "6",
  //   target: "8",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e7-9",
  //   source: "7",
  //   target: "9",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e8-10",
  //   source: "8",
  //   target: "10",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e9-10",
  //   source: "9",
  //   target: "10",
  //   style: { stroke: level6 },
  //   animated: true,
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-11",
  //   source: "3",
  //   target: "11",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-12",
  //   source: "3",
  //   target: "12",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-13",
  //   source: "3",
  //   target: "13",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-14",
  //   source: "3",
  //   target: "14",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-15",
  //   source: "3",
  //   target: "15",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-16",
  //   source: "3",
  //   target: "16",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-17",
  //   source: "3",
  //   target: "17",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-18",
  //   source: "4",
  //   target: "18",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-19",
  //   source: "4",
  //   target: "19",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-20",
  //   source: "4",
  //   target: "20",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-21",
  //   source: "4",
  //   target: "21",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-22",
  //   source: "4",
  //   target: "22",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-30",
  //   source: "4",
  //   target: "30",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e5-23",
  //   source: "5",
  //   target: "23",
  //   // label: "this is an edge label",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e23-24",
  //   source: "23",
  //   target: "24",
  //   // label: "this is an edge label",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e19-25",
  //   source: "19",
  //   target: "25",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e20-25",
  //   source: "20",
  //   target: "25",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e21-25",
  //   source: "21",
  //   target: "25",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e22-25",
  //   source: "22",
  //   target: "25",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e30-25",
  //   source: "30",
  //   target: "25",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e25-26",
  //   source: "25",
  //   target: "26",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e25-27",
  //   source: "25",
  //   target: "27",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e25-28",
  //   source: "25",
  //   target: "28",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e25-29",
  //   source: "25",
  //   target: "29",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  //END
];
